// extracted by mini-css-extract-plugin
export var bgOverlay = "title-overlay-hero-module--bg-overlay--BNF23";
export var btn = "title-overlay-hero-module--btn--uUwYK";
export var chapterHero = "title-overlay-hero-module--chapterHero--ooIFz";
export var collapseOverlay = "title-overlay-hero-module--collapse-overlay--8yQus";
export var collapseSubtitle = "title-overlay-hero-module--collapse-subtitle--Vj8bK";
export var collapseText = "title-overlay-hero-module--collapse-text--YP9MN";
export var detailHero = "title-overlay-hero-module--detailHero--fpkI8";
export var hero = "title-overlay-hero-module--hero--fQ2tY";
export var listen = "title-overlay-hero-module--listen--Io3kn";
export var subtitle = "title-overlay-hero-module--subtitle--g95NO";
export var subtitleContainer = "title-overlay-hero-module--subtitle-container--PW1u-";
export var textOverlay = "title-overlay-hero-module--text-overlay---oaCO";
export var titleContainer = "title-overlay-hero-module--title-container--6Dw9E";